var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-table",
    { attrs: { data: _vm.tableList, border: "" } },
    [
      _vm._l(_vm.tableHead, function (item) {
        return [
          _c("el-table-column", {
            key: item.No,
            attrs: {
              prop: item.columnName,
              label: item.columnComment,
              width: item.width,
              "header-align": "center",
              align: item.align || "center",
            },
          }),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }